export default __webpack_public_path__ + "static/illustration-card-three.url-98184776aa0af00f81a9c419610bde66.svg";